import React, { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import Service from '../../../services';
import { baseUrlAdmin } from '../../../store/apiConstants';
import LoadingComponent from '../../loadingComponent';
import { format } from 'date-fns';

class StaffVehicleView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            currentAssignments: [],
            assignmentHistory: []
        };
        this.service = new Service();
    }

    componentDidMount() {
        if (this.props.visible) {
            this.loadStaffAssignments();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible) {
            this.loadStaffAssignments();
        }
    }

    loadStaffAssignments = async () => {
        this.setState({ isLoading: true });
        try {
            await Promise.all([
                this.getCurrentAssignments(),
                this.getAssignmentHistory()
            ]);
        } catch (error) {
            console.error('Error loading staff assignments:', error);
            this.toast?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to load vehicle assignments',
                life: 3000
            });
        } finally {
            this.setState({ isLoading: false });
        }
    };

    getCurrentAssignments = async () => {
        const url = `${baseUrlAdmin}/vehicle-staff-assignment/staff/${this.props.staffId}/current`;
        try {
            const res = await this.service.get(url, true);
            if (res?.status && res?.res?.status) {
                this.setState({ currentAssignments: res.res.data || [] });
            }
        } catch (error) {
            console.error('Error fetching current assignments:', error);
        }
    };

    getAssignmentHistory = async () => {
        const url = `${baseUrlAdmin}/vehicle-staff-assignment/staff/${this.props.staffId}/history`;
        try {
            const res = await this.service.get(url, true);
            if (res?.status && res?.res?.status) {
                this.setState({ assignmentHistory: res.res.data || [] });
            }
        } catch (error) {
            console.error('Error fetching assignment history:', error);
        }
    };

    render() {
        const { visible, onHide, staffName } = this.props;
        const { currentAssignments, assignmentHistory, isLoading } = this.state;

        return (
            <>
                <Dialog
                    visible={visible}
                    onHide={onHide}
                    header={`Vehicle Assignments - ${staffName}`}
                    style={{ width: '80vw' }}
                    draggable={false}
                    blockScroll={true}
                >
                    {isLoading && <LoadingComponent />}

                    <div className="p-3">
                        <h3 className="mb-3 text-center">Current Assignments</h3>
                        {currentAssignments.length > 0 ? (
                            <div className="grid justify-content-center">
                                {currentAssignments.map((assignment, index) => (
                                    <div key={index} className="col-12 md:col-6">
                                        <Card className="mb-3">
                                            <div className="grid">
                                                <div className="col-6">
                                                    <p className="font-semibold">Vehicle Name:</p>
                                                    <p>{assignment.vehicleId?.vehicleName || 'N/A'}</p>
                                                </div>
                                                <div className="col-6">
                                                    <p className="font-semibold">Registration No:</p>
                                                    <p>{assignment.vehicleId?.vehicleRegistrationNo || 'N/A'}</p>
                                                </div>
                                                <div className="col-6">
                                                    <p className="font-semibold">Role:</p>
                                                    <p>{assignment.role || 'N/A'}</p>
                                                </div>
                                                <div className="col-6">
                                                    <p className="font-semibold">Start Date:</p>
                                                    <p>{assignment.startDate ? format(new Date(assignment.startDate), 'dd MMM yyyy') : 'N/A'}</p>
                                                </div>
                                            </div>
                                        </Card>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p className="text-center text-gray-500 my-4">No current vehicle assignments</p>
                        )}

                        <h3 className="mb-3 mt-5 text-center">Assignment History</h3>
                        <DataTable
                            value={assignmentHistory}
                            paginator
                            rows={10}
                            emptyMessage="No assignment history found"
                            className="p-datatable-sm"
                        >
                            <Column
                                header="Vehicle Name"
                                body={(rowData) => rowData.vehicleId?.vehicleName || 'N/A'}
                                style={{ textAlign: 'center' }}
                                headerStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                header="Registration No"
                                body={(rowData) => rowData.vehicleId?.vehicleRegistrationNo || 'N/A'}
                                style={{ textAlign: 'center' }}
                                headerStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                header="Role"
                                field="role"
                                style={{ textAlign: 'center' }}
                                headerStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                header="Start Date"
                                body={(rowData) => rowData.startDate ? format(new Date(rowData.startDate), 'dd MMM yyyy') : 'N/A'}
                                style={{ textAlign: 'center' }}
                                headerStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                header="End Date"
                                body={(rowData) => rowData.endDate ? format(new Date(rowData.endDate), 'dd MMM yyyy') : 'Current'}
                                style={{ textAlign: 'center' }}
                                headerStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                header="Status"
                                body={(rowData) => (
                                    <span className={`px-2 py-1 border-round ${rowData.isActive ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                                        {rowData.isActive ? 'Active' : 'Inactive'}
                                    </span>
                                )}
                                style={{ textAlign: 'center' }}
                                headerStyle={{ textAlign: 'center' }}
                            />
                        </DataTable>
                    </div>
                </Dialog>

                <Toast ref={(el) => (this.toast = el)} position="bottom-right" />
            </>
        );
    }
}

export default StaffVehicleView;
